import { useQuery } from "@tanstack/react-query";

import { axios } from "@features/config";

import { Application } from "@dto/application";

import { AI_SUPPORT } from "./type";

// type Response = {
//   totalItems: number;
//   jobs: GetJobByProjectDto[];
// };

type GetJobByProjectType = Application & { hasNewUpdate: boolean; model: string };
const getApplicationsByJob = async (
  jobId: string,
  params?: any
): Promise<GetJobByProjectType[]> => {
  const res = await axios.get(`job/${jobId}/applications`, { params });
  const applications = res?.data?.data || [];
  // Add all AI_SUPPORT entries as application objects at the top
  const aiApplications = Object.entries(AI_SUPPORT).map(([id, ai]) => ({
    id,
    ...ai,
  }));
  applications.unshift(...aiApplications);
  return applications;
};

const useGetApplicationsByJob = (jobId: string, params?: any) =>
  useQuery(
    ["getApplicationsByJob", jobId, params],
    () => getApplicationsByJob(jobId, params),
    { enabled: !!jobId }
  );

export default useGetApplicationsByJob;
